// Data for codes of conduct that we fetch from GitHub.

export default [
  {
    id: 'citizen_code_of_conduct',
    name: 'Contributor Covenant',
  },
];
